module.exports = __webpack_public_path__ + "img/tips.729925b2.png";